import { gql } from "@apollo/client";

export const AssetNodeType = gql`
    query AssetNodeType ($id: ID!) {
        assetLocation (id: $id) {
            id
            asset {
                id
                serialNumber
            }
            installedBaseNode {
                id
                nodeType {
                    key
                    id
                }
            }
        }
    }
`;
